<template>
  <div
    class="campaigns-card d-flex"
    :class="{
      'active-card': data.isApplied,
    }"
    data-cy="promo-campaign-card"
  >
    <div class="d-flex fl-j-c fl-a-c picture-container">
      <img v-if="data.picture" :src="data.picture" />
      <!-- else show first letter -->
      <div v-else class="f-bold picture-placeholder">
        {{ data.name.charAt(0) }}
      </div>
    </div>
    <div class="d-flex flex-column fl-s-b details-container">
      <p class="f-bold name">{{ data.name }}</p>
      <p class="code">{{ data.code }}</p>
      <p class="f-bold value">
        {{
          data.flatValue
            ? (data.flatValue / 100).toFixed(2)
            : `${data.percentageValue}%`
        }}
      </p>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from "vue";
import { defineComponent } from "vue";
import { IPromocodeCardData } from "@/types/db/promocode-campaign";

export default defineComponent({
  name: "promocode-campaign-card",
  props: {
    data: {
      required: true,
      type: Object as PropType<IPromocodeCardData>,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;
$btns-height: 40px;

.campaigns-card {
  width: 220px;
  height: 75px;
  background-color: #fff;
  border: 1px solid rgba(229, 238, 238, 1);
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  color: #2a2c33;

  .picture-container {
    height: 100%;
    aspect-ratio: 2/3;
    font-size: 24px;
    background-color: #eee;
    border-radius: 4px 0 0 4px;
    color: #2a2c33;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 4px 0 0 4px;
    }
  }

  .details-container {
    padding: 6px 8px;
    width: calc(100% - (75px * 2 / 3));

    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      margin: 0;
    }

    .code {
      font-size: 12px;
    }
  }
}
.active-card {
  background-color: #1d5f64;
  border-color: #1d5f64;
  color: #fff;
}
</style>
